import { createContext, ReactNode } from "react";
import type { ButtonProps } from "@mui/material/Button";
import { UsePopover } from "helpers/hooks/usePopover";

export interface Confirm {
  title: string;
  prompt: ReactNode | undefined;
  callback: () => Promise<any | void>;
  confirmButtonText?: string;
  confirmButtonProps?: ButtonProps;
  cancelButtonprops?: ButtonProps;
  cancelButtonProps?: ButtonProps;
  usePopover?: UsePopover;
}

export interface ConfirmationDialogState {
  open: boolean;
  confirming: boolean;
  title: string;
  prompt: ReactNode | undefined;
  callback: () => Promise<any | void>;
  confirmButtonText?: string;
  confirmButtonProps?: ButtonProps;
  cancelButtonProps?: ButtonProps;
  usePopover?: UsePopover;
  onCancel: () => void;
  onConfirm: () => Promise<void>;
  confirm: (c: Confirm) => void;
}

export const ConfirmationDialogContext = createContext<ConfirmationDialogState>(null!);
